import ILanguage from "@/admin/helpers/interfaces/language-types";
import { API_SITE_CORPO } from "../api_endpoint";
import { http  } from '../http';
 

export const getAllLanguages = async ( ) => {  
	try {
		let x=API_SITE_CORPO.LANGUAGE 
		let { data } = await http.get(x);
		
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};
 
export const saveLanguage = async (language: ILanguage) => {  

	try {
		let x=API_SITE_CORPO.LANGUAGE   
		let { data } = await http.post(x,language);
		return data;
	} catch (error: any) {
		const errorMessage = error.response && error.response.data ? error.response.data.errors : 'An error occurred while processing your request. Please try again.';
		throw errorMessage; 	
	}
};

export const editLanguage = async ( language:any) => {  
	try {
		const lang = {
			flag: language.get("flag"),
			language: language.get("language"),
			iSOCode: language.get("iSOCode"),
	}
		let x=API_SITE_CORPO.LANGUAGE +"/"+ language.get("id")
		let { data } = await http.put(x,lang);
		return data;
	} catch (error: any) {
		const errorMessage = error.response && error.response.data ? error.response.data.errors : 'An error occurred while processing your request. Please try again.';

		throw errorMessage; 
	}
};

export const deleteLanguage =async (id: string) => {
	try {
		let x=API_SITE_CORPO.LANGUAGE +"/"+ id
		let { data } = await http.delete(x);
		return data;
	} catch (error: any) {
		const errorMessage = error.response && error.response.data ? error.response.data.errors : 'An error occurred while processing your request. Please try again.';
		throw errorMessage; 
	}
}